<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VFormModified from "@/components/commonComponents/VFormModified.vue";
import CommonRules from "@/mixins/CommonRules";
import UserAuth from "@/mixins/UserAuth";

export default {
    name: "CompanyModal",
    components: {
        VFormModified,
        AjaxLoad,
    },
    mixins: [
        CommonRules,
        UserAuth,
    ],
    data() {
        return {
            isShow: false,
            isResolved: false,
            isValid: false,
            isSubmit: false,
            wasModified: false,
            result: false,
            idCompany: null,
            loadPromise: null,
            original: {},
            data: {},
            notifyOptions: {
                title: 'Компания',
            },
        };
    },
    computed: {
        isDisabled() {
            return this.isNew ?
                !this.user?.permissions?.byModule?.companies?.canCreate :
                !(this.user?.permissions?.byModule?.companies?.canUpdate && this.data?.permissions?.canUpdate);
        },
        isCanSubmit() {
            return !this.isDisabled && this.isValid && this.wasModified && !this.isSubmit && this.isResolved;
        },
        isNew() {
            return !this.idCompany;
        },
        isLoading() {
            return !this.isResolved || this.isSubmit;
        },
        loadUrl() {
            return this.$apiUrl.getCompanyUrl({
                id_company: this.idCompany,
            });
        },
        saveUrl() {
            return this.isNew ?
                this.$apiUrl.getCompaniesUrl() :
                this.loadUrl;
        },
    },
    watch: {
        isShow(v) {
            if (!v) {
                this.resolve(this.result);
                this.result = false;
            }
        },
    },
    methods: {
        show(idCompany) {
            this.idCompany = idCompany;
            this.loadPromise = this.isNew ? Promise.resolve({data: {data: {}}}) : this.$api.get(this.loadUrl);
            this.isShow = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        onClickSave() {
            this.isSubmit = true;
            const method = this.isNew ? 'post' : 'put';
            this.$api[method](this.saveUrl, this.data)
                .then((response) => {
                    this.result = response;
                    this.notifySuccess('Успешно сохранена');
                    this.close();
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        onClickCancel() {
            this.close();
        },
        close() {
            this.isShow = false;
        },
        isDisabledField(field) {
            return this.isNew ?
                !this.user?.permissions?.byModule?.companies?.canCreate :
                !(this.user?.permissions?.byModule?.companies?.canUpdate && this.data?.permissions?.isEditableField[field]);
        },
    },
}
</script>

<template>
    <v-dialog
        v-if="isShow"
        v-model="isShow"
        :persistent="wasModified"
        max-width="500px"
        scrollable
    >
        <ajax-load
            v-model="original"
            :promise="loadPromise"
            :transform="response => response.data.data"
            :resolved.sync="isResolved"
        >
            <v-form-modified
                v-model="isValid"
                :original="original"
                :modified.sync="data"
                :was-modified.sync="wasModified"
                :disabled="isLoading"
                @submit.prevent="onClickSave"
            >
                <v-card :loading="isLoading">
                    <v-card-title>{{ isNew ? 'Создание' : 'Редактирование' }}</v-card-title>
                    <v-card-text>
                        <v-container class="pa-0">
                            <v-row no-gutters>
                                <v-col>
                                    <v-text-field
                                        v-model="data.name"
                                        :rules="[rules.requiredTrim]"
                                        :disabled="isDisabledField('name')"
                                        label="Компания"
                                        class="required"
                                        autofocus
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="onClickCancel">
                            Отмена
                        </v-btn>
                        <v-btn
                            :disabled="!isCanSubmit"
                            color="primary"
                            type="submit"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form-modified>
        </ajax-load>
    </v-dialog>

</template>

<style scoped lang="scss">

</style>